import { Expose } from "class-transformer";

export class UpdatePayrollDto {
  @Expose()
  notes?: string;

  @Expose()
  deadlineDate?: Date | null;
}
